import { z } from "zod";

export const accessPolicyModeSchema = z.enum(["allow_list", "deny_list"]);

export const accessPolicyProfessionalSchema = z.object({
	profId: z.string(),
	name: z.string(),
	email: z.string(),
	isActive: z.boolean(),
	role: z.string(),
	profType: z.string().nullable(),
	department: z.string().nullable(),
	practiceType: z.string().nullable(),
	isLicensed: z.boolean(),
});

export const accessPolicySchema = z.object({
	object: z.literal("access_policy"),
	clientCode: z.string(),
	matterId: z.string().nullable(),
	mode: accessPolicyModeSchema,
	professionals: z.array(accessPolicyProfessionalSchema),
});

export const accessPolicyProfessionalListSchema = z.object({
	object: z.literal("list"),
	url: z.literal("/v2/access-policies/professionals"),
	hasMore: z.boolean(),
	data: z.array(accessPolicyProfessionalSchema),
});

export type AccessPolicyMode = z.infer<typeof accessPolicyModeSchema>;
export type AccessPolicyProfessional = z.infer<
	typeof accessPolicyProfessionalSchema
>;
export type AccessPolicy = z.infer<typeof accessPolicySchema>;

export type AccessPolicyScope = {
	clientCode: string;
	matterId: string | null;
};

export type AccessPolicyDraft = {
	mode: AccessPolicyMode;
	professionalIds: string[];
};

export type ReplaceAccessPolicyBody = AccessPolicyScope & AccessPolicyDraft;
